class FormFindRestaurant extends ViewBasic {
    constructor(options) {
        super(options);

        //set default variables
    }

    init(){
        this.inModal = this.$el.parents('.modal').length > 0;

        this.geocoder = new google.maps.Geocoder();
        this.$location = this.$('#location');

        this.type = (this.$el.attr('method')) ? this.$el.attr('method') : 'get';
        this.action = this.$el.attr('action');

        this.addEvents();
    }

    addEvents() {
        this.$el.on('submit', e => this.handleForm(e));
        this.$('.btn-submit').on('click', e => {this.$el.trigger('submit');});

        if(this.inModal){
            Me.dispatch.subscribe('modal-content-deleted', () => this.terminate());
        }
    }

    removeEvents() {
        if(this.inModal){
            Me.dispatch.unsubscribe('modal-content-deleted');
        }
    }

    terminate(){
        this.removeEvents();
    }

    handleForm(e){
        e.preventDefault();

        if(this.antiSpam) {return;}
        this.antiSpam = true;

        if(this.$location.val()){
            this.$location.removeClass('error');

            this.geocoder.geocode({ 'address':this.$location.val() + ', Canada'}, $.proxy(function(results, status) {
                if (status == 'OK') {
                    Me.track.event("Locator", "Search", "Geocode");

                    let destination = null;

                    $.each(results, (index,value)=>{
                        if(value.types.includes('locality')){
                            destination = value;
                        }
                    });

                    destination = (destination) ? destination : results[0];

                    this.searchPosition = {
                        'lat': destination.geometry.location.lat(),
                        'lng': destination.geometry.location.lng()
                    };

                    this.handleAjax(this.searchPosition);
                } else {
                    this.$location.addClass('error');
                    this.antiSpam = false;
                }
            }, this));
        } else{
            this.$location.addClass('error');
            this.antiSpam = false;
        }
    }

    handleAjax(data){
        let options = {
            method: this.type,
            url: this.action + '?lat=' + data.lat + '&lng=' + data.lng + '&lang=' + $('#site-ctn').attr('data-lang'),
            dataType: 'json',
            success: $.proxy(this.ajaxSuccess, this),
            error: $.proxy(this.ajaxError, this)
        };

        Me.dispatch.emit('loading.restaurant.list');
        $.ajax(options);
    }

    ajaxSuccess(data){
        Me.dispatch.emit('update.restaurant.list', this, {'data': data, 'position': this.searchPosition});
        fbq('track', 'FindLocation');
        this.antiSpam = false;
    }

    ajaxError(error){
        this.antiSpam = false;
    }
}
